import { Route, Routes } from "react-router-dom"; 
import NavBar from "./components/layoutComponents/navBar/NavBar";
import Footer from "./components/layoutComponents/footer/Footer";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import Support from "./pages/Support";
import WaitingList from "./pages/WaitingList";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import VotingPage from "./pages/VotingPage";
import StreamingPage from "./pages/StreamingPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <>
      <NavBar />
      <Routes> 
        <Route path="/" element={<Home />} />
        <Route path="/support" element={<Support />} />
        <Route path="/waiting-list" element={<WaitingList />} />
        <Route path="/signUp" element={<SignUp />} />
        <Route path="/signIn" element={<SignIn />} />
        <Route path="*" element={<NotFound />} />
        <Route
          path="/voting"
          element={
            <ProtectedRoute role="viewer">
              <VotingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/streaming"
          element={
            <ProtectedRoute>
              <StreamingPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
